<script setup lang="ts">

import { ICarbucksGuaranteeFeature } from "@domain/CarePlan";
import { FeatureFrame } from "../Components";

const model = defineModel<ICarbucksGuaranteeFeature>( { required: true } ); 

</script>

<template>

    <!-- CARBUCKS GUARANTEE -->
    <FeatureFrame>

        <template #title>{{ model.title }}</template>
        <template #sub-title>You have Carbucks GUARANTEE</template>

        <div class="flex flex-col w-full pt-4">

        </div>
        
   </FeatureFrame>
        
</template>
